import { render, staticRenderFns } from "./forecastimport.vue?vue&type=template&id=204a5c6c&scoped=true&"
import script from "./forecastimport.vue?vue&type=script&lang=js&"
export * from "./forecastimport.vue?vue&type=script&lang=js&"
import style0 from "./forecastimport.vue?vue&type=style&index=0&id=204a5c6c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a5c6c",
  null
  
)

export default component.exports